export default __webpack_public_path__ + "static/media/formImg.91c71c76.png";